'use client';
var COMPONENT_ID = "FocusTrap";
var defaultProps = {
    active: true,
    refProp: "ref"
};

export { COMPONENT_ID, defaultProps };
